import automationListApi from "./API/automation-lists-api";
import birthdayListApi from "./API/birthday-lists-api";
import tasksApi from "./API/tasks-api";
import notesApi from "./API/notes-api";
import dealsApi from "./API/deals-api";
import stepsApi from "./API/steps-api";
import campaignsApi from "./API/campaigns-api";
import usersApi from "./API/users-api";
import clientsApi from "./API/clients-api";
import architectsApi from "./API/architects-api";
import pipesApi from "./API/pipes-api";
import imagesApi from "./API/images-api";
import filesApi from "./API/files-api";
import originsApi from "./API/origins-api";
import companiesApi from "./API/companies-api";
import productsApi from "./API/products-api";
import apiServicesApi from "./API/api-services-api";
import labelsApi from "./API/labels-api";
import ecommerceActionsApi from "./API/ecommerce-actions-api";
import whatsappChatsApi from "./API/whatsapp-chats-api";
import proxyApi from "./API/proxy-api";
import optinsApi from "./API/optins-api";
import productCategoryApi from "./API/productCategory-api";
import paymentMethodsApi from "./API/payment-methods-api";
import templatesApi from "./API/templates-api";
import webhooksApi from "./API/webhooks-api";
import recurrencesApi from "./API/recurrences-api";
import LossReasonsApi from "./API/loss-reasons-api";
import landingPagesApi from "./API/landing-pages-api";
import customMessagesApi from "./API/custom-messages-api";
import extrainfosApi from "./API/extrainfos-api";
import schedulingWhatsApi from "./API/scheduling-whats-api";
import dealsLogsApi from "./API/deals-logs-api";
import taskTypesApi from "./API/task-types-api";
import rolesApi from "./API/roles-api";
import productsClassesGroupsApi from "./API/products-classes-groups-api";
import formulasApi from "./API/formulas-api";
import formulas from "../store/modules/formulas/formulas";

let api = {
    tasks : tasksApi,
    notes : notesApi,
    deals : dealsApi,
    steps : stepsApi,
    campaigns : campaignsApi,
    users : usersApi,
    clients : clientsApi,
    architects : architectsApi,
    pipes : pipesApi,
    images : imagesApi,
    files : filesApi,
    origins : originsApi,
    companies : companiesApi,
    products : productsApi,
    automationLists : automationListApi,
    apiServices : apiServicesApi,
    labels : labelsApi,
    ecommerceActions : ecommerceActionsApi,
    whatsappChats : whatsappChatsApi,
    proxy : proxyApi,
    optins : optinsApi,
    productCategory: productCategoryApi,
    paymentMethods : paymentMethodsApi,
    birthdayLists : birthdayListApi,
    templates: templatesApi,
    recurrences : recurrencesApi,
    lossReasons: LossReasonsApi,
    landingPages: landingPagesApi,
    
    webhooks: webhooksApi,
    customMessages: customMessagesApi,
    extrainfos: extrainfosApi,
    schedulingWhats: schedulingWhatsApi,
    dealsLogs: dealsLogsApi,
    taskTypes: taskTypesApi,
    roles: rolesApi,
    productsClassesGroups: productsClassesGroupsApi,
    formulas: formulasApi
};

export default api;
